import { defaultSession } from 'reducers/session';
import { defaultLoader } from 'reducers/loader';

const preloadState = {
  session: defaultSession,
  loader: defaultLoader,
};

export default preloadState;
